import { uuidv5 } from '@/util/util'
// 分页位置
export const PAGINATION_POSITION = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'flex-center'
}
// 表格尺寸
export const TABLE_SIZE = {
  MEDIUM: {
    value: 'medium',
    label: '默认'
  },
  SMALL: {
    value: 'small',
    label: '中等'
  },
  MINI: {
    value: 'mini',
    label: '紧凑'
  }
}
// 列显示
export const COLUMN_OPERATION = [
  {
    label: '列展示',
    show: false,
    indeterminate: false,
    id: 1
  },
  {
    label: '序号',
    show: false,
    id: 2
  },
  {
    label: '勾选',
    show: false,
    id: 3
  }
]
// 固定的选择项
export const COLUMN_SELECTION = {
  type: 'selection',
  width: 60,
  align: 'center',
  fixed: 'left',
  checked: true,
  id: uuidv5()
}
// 固定的序号项
export const COLUMN_INDEX = {
  // type: 'index',
  label: '序号',
  fixed: 'left',
  width: 50,
  align: 'center',
  prop: 'sortIndex',
  checked: true,
  id: uuidv5()
}
export const TABLE_SETTINGS = [
  {
    label: '表格尺寸',
    value: 'size',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAHNJREFUOE/Fk8sNgDAMQ/FOHgAmAyaDAbJTUJCKQkVRpPDJpRf71VVcdMmB95PsIzwRWYvuAJhZVZcIAMBQIKcEEXOtuQWQnMwgIvt5NU2AmVV1NJOP/F0Cuyn1hP8BvhcA5tYm3ltjtFTPVjn1maKRa90GPqdAEYv3TqwAAAAASUVORK5CYII=',
    size: 16,
    name: 'TableSize',
    list: [
      {
        label: '默认',
        value: 'medium'
      },
      {
        label: '中等',
        value: 'small'
      },
      {
        label: '紧凑',
        value: 'mini'
      }
    ]
  },
  /* {
    label: '表格边框',
    value: 'border',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAIJJREFUOE9jNDY2/s9AAWCEGWBoaIhhDCMjI8P//9jNP3/+PFg92ACQ5kmTp2AYsGP7drCYh6cnhlxebg4DyJBRA5DCwMvLGyOg7ty5AxZTUVHBkNu+fRvDuXPnIIFoZGTE4OnpRZIB27ZtHY0FqqZEUPBjy0zgzIIjQ6FkJgpyMwMAmpGRkYcSZNwAAAAASUVORK5CYII=',
    size: 16,
    name: 'TableBorder'
  }, */
  {
    label: '对齐方式',
    value: 'align',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAIZJREFUOE+1k8ERgCAMBElP+auViZWJ/1BTHBhgEMQhiry5JXcXQH08EPWIqCUsIvL3PQARZ2beJQAA2BwkTSAR53fHAIKFtZwCAI7otTVhnkEFcCJr7fJkb4yFtwHmNWpmniSgUKNJGSil3C50Qy4AyctVU1/EZQZ3NZruGhufyRCR+XUPTs9YOBGQBYlnAAAAAElFTkSuQmCC',
    size: 16,
    name: 'TableAlign',
    list: [
      {
        label: '左对齐',
        value: 'left'
      },
      {
        label: '居中',
        value: 'center'
      },
      {
        label: '右对齐',
        value: 'right'
      }
    ]
  },
  {
    label: '全屏',
    value: 'fullScreen',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAKxJREFUOE+1kkEOwyAMBO034XuSlyV9WZK7/SZXW8kVJdCoaeCEwIwG7TLdtPgmDvUDicgYlqq6lcat+w8jDLn7SkQbMz8aoMXdByIazez9vgaaMcTM0wmIzGwK4wMIEBjBrISJyMsGAOxVdamC/kmwX2pXrfoboQplatGhWpqt1CjSyb8aPUOa7j5/jT8KmQ/VYDg7K2Q0e897ErCUEu6x2s2+mhje9U/tV7snuhZxE0Xtzz4AAAAASUVORK5CYII=',
    size: 18,
    name: 'TableFullScreen'
  },
  {
    label: '表格列设置',
    value: 'columns',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQ9JREFUOE+tVEEOwyAMI2+C+7qXrX1Zuzu8ickII5fSrpO24xIb20lq7uIXQphYjjFuV732hWjOOb9qz5ZSep7174iqginGOAPgvV/N7O2c20BIohAC6puqbEQgyTmvaHDO0VJRUWtQhv9pcTKzJ8mUCDYeFXh4EQqZGcBUS/U7a7W4qGQFMx9Yq1YbvifKlNtZBUezwlpKaU8EJXyNgXrvQQp1JfheBTEchpEdSgCALYbbj7u3TnJglUhfxwTbuKlWiZgdJt2I4B8TA+BXa8T8N2yRvgu43x0Z/8H62UKWze4PVU/odCFHe4NzqCtQNllPR/cKj9452oXDuHW0o8+DqtDlHPVefo807FFmSvgB6vQotorRewIAAAAASUVORK5CYII=',
    size: 18,
    name: 'TableColumn'
  }
]
